module.exports = __webpack_public_path__ + "static/media/cash.96980245.svg";